export const API_URL_HACKATAO_CLAIM_TRAIT = "/hackatao/claimtraits/";
export const API_URL_HACKATAO_LEARN_MORE = "/hackatao/learnmore/";
export const API_URL_HACKATAO_GRID_AVATARS = "/hackatao/gridavatar/";
export const API_URL_HACKATAO_MAIN_AVATARS = "/hackatao/mainavatar/";
